<template>
  <div >
    <button v-if="hoso_hdld_cud" class="btn btn-info mb-2 mr-2" @click.prevent="openModal">
      <i class="fas fa-plus"></i>
      Add
      <!-- Thêm -->
    </button>
    <button v-if="hoso_hdld_cud && this.items.length < 1" class="btn btn-info mb-2 mr-2" @click.prevent="openAllModal">
      <i class="fas fa-plus"></i>
      Add group
      <!-- Thêm nhóm -->
    </button>
    <b-table
      bordered
      head-variant="dark"
      hover
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
      v-if="hoso_hdld_read"
    >
      <template v-slot:cell(phucap)="data">
        {{findFirst(phucaps, data.value)}}
        <!-- <b-link href="#" @click="openUpdateModal(data)">{{findFirst(phucaps, data.value)}}</b-link> -->
      </template>
      <template v-slot:cell(tungay)="data">{{data.item.tungay | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(denngay)="data">{{data.item.denngay | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(tien) = "data"> {{data.item.tien | numeral('0,0') }}</template>
      <!-- Permission: Update + Delete -->
      <template v-slot:cell(action)="data" v-if="hoso_hdld_cud">
        <b-link class="text-primary mr-2" href="#" @click="openUpdateModal(data)">
          <i class="fas fa-pencil-alt"></i>
        </b-link>
        <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)">
          <i class="fas fa-trash"></i>
        </b-link>
      </template>
    </b-table>

    <!-- NORMAL MODAL -->
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="item.id <= 0">
          Add allowance
          <!-- Thêm thông tin phụ cấp -->
        </div>
        <div v-else>
          Update allowance
          <!-- Cập nhật thông tin phụ cấp -->
        </div>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit.prevent="ok()">
        <!-- <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Từ ngày</label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              style="width: 100%"
              v-model="item.tungay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">Đến ngày</label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              style="width: 100%"
              v-model="item.denngay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
        </b-form-row> -->

         <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">From date
              <!-- Từ ngày -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <my-date-picker v-model="tungay_selected"></my-date-picker>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">
              To date
              <!-- Đến ngày -->
            </label>
          </b-col>
          <b-col cols="3">
            <my-date-picker v-model="denngay_selected"></my-date-picker>
          </b-col>
        </b-form-row>

        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Allowance
              <!-- Phụ cấp -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <b-form-select
              v-model="item.phucap"
              :options="phucaps"
              value-field="id"
              text-field="pickListValue"
            ></b-form-select>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">
              Amount
              <!-- Tiền -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <my-currency-input v-model="item.tien" />
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="11" class="form-inline">
            <div  style="flex-grow: 1"></div>
            <b-button class="mr-3" variant="info" v-if="itemIdex == null" @click.prevent="storeItem">
              <i class="fas fa-save mr-2"></i>Lưu
            </b-button>
            <b-button  class="mr-3" variant="info" v-else @click.prevent="updateItem">
              <i class="fas fa-save mr-2"></i>Save
              <!-- Lưu -->
            </b-button>
            <b-button variant="secondary" @click="closeModal">
              <i class="fas fa-times mr-2"></i>Close
              <!-- Đóng -->
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
    <!-- NORMAL MODAL END -->

    <!-- ALL MODAL -->
    <b-modal
      v-model="modalAllShow"
      header-bg-variant="info"
      header-text-variant="light"
      @hidden="closeAllModal"
      hide-footer
    >
      <template v-slot:modal-title>
        ADD ALL ALLOWANCES
        <!-- THÊM TẤT CẢ CÁC PHỤ CẤP -->
      </template>
      <b-form class="mr-4" autocomplete="off" @submit.prevent="storeAllItem">
         <b-form-row class="mb-4">
          <b-col cols="4">
            <label class="mr-2">
              Gas
              <!-- Xăng xe -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="8">
            <my-currency-input v-model="item_all.xangxe"/>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="4">
            <label class="mr-2">
              Mobile phone
              <!-- Điện thoại -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="8">
            <my-currency-input v-model="item_all.dienthoai"/>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="4">
            <label class="mr-2">
              House rental
              <!-- Nhà ở -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="8">
            <my-currency-input v-model="item_all.nhao"/>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="4">
            <label class="mr-2">
              Travel
              <!-- Đi lại //Update 20241018: Thay đổi thứ tự phụ cấp, thay thế phụ cấp (Trang phục (Clothing) -> Đi lại (Travel)) -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="8">
            <my-currency-input v-model="item_all.trangphuc"/>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="4">
            <label class="mr-2">
              Child-care
              <!-- Hỗ trợ nuôi con -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="8">
            <my-currency-input v-model="item_all.hotronuoicon"/>
          </b-col>
        </b-form-row>
        <b-button style="float:right" class="mr-3" variant="info" type="submit">
          <i class="fas fa-save mr-2"></i>Save
          <!-- Lưu -->
        </b-button>
      </b-form>
    </b-modal>
    <!-- ALL MODAL END -->
  </div>
</template>

<script>
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyCurrencyInput from "../App/MyCurrencyInput";
import MyDatePicker from  "../App/MyDatePicker";
export default {
  name: "HopDongLaoDongPhuCap",
  components: {
    MyCurrencyInput,
    // VueDatepickerLocal,
    MyDatePicker,
  },
  props: ["phucaps", "hopdong"],
  data() {
    return {
      fields: [
        {
          key: "tungay",
          label: "From date",
          // label: "Từ ngày",
        },
        {
          key: "denngay",
          label: "To date",
          // label: "Đến ngày",
        },
        {
          key: "phucap",
          label: "Allowance",
          // label: "Phụ cấp",
        },
        {
          key: "tien",
          label: "Amount",
          // label: "Tiền",
          tdClass: 'text-right',
          thClass: 'text-right',
          thStyle: { width: "150px" },
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "75px !important" },
        },
      ],
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
      items: [],
      modalShow: false,
      modalAllShow: false,
      item_null: {
        id: 0,
        employeeContractId: 0,
        tungay: null,
        denngay: null,
        phucap: null,
        tien: 0,
      },
      item: {
        id: 0,
        employeeContractId: 0,
        tungay: null,
        denngay: null,
        phucap: null,
        tien: 0,
      },
      item_all: {
        xangxe: 0,
        dienthoai: 0,
        nhao: 0,
        trangphuc: 0,
        hotronuoicon: 0,
      },
      is_update: false,
      itemIdex: null,
      tungay_selected: "",
      denngay_selected: "",
    };
  },
  created() {
    if (this.hopdong != null) this.initData();
  },
  computed: {
    hoso_hdld_read() {
      return this.$store.getters.hasPermission("hoso_hdld_read");
    },
    hoso_hdld_cud() {
      return this.$store.getters.hasPermission("hoso_hdld_cud");
    },
  },
  methods: {
    initData() {
      if (this.hopdong.employeeContractAllowances)
      {
        this.items = JSON.parse(
          JSON.stringify(this.hopdong.employeeContractAllowances)
        );
      }
    },
    findFirst(list, id) {
      const temp = list.find(function (el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    openModal() {
      this.item = JSON.parse(JSON.stringify(this.item_null));
      this.itemIdex = null;
      this.modalShow = true;
      // this.tungay_selected = this.$convert_date_string(this.item.tungay);
      // this.denngay_selected = this.$convert_date_string(this.item.denngay);
    },
    openAllModal() {
      this.modalAllShow = true;
    },
    closeAllModal() {
      this.modalAllShow = false;
    },
    openUpdateModal(data) {
      this.item = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalShow = true;
      this.tungay_selected = this.$convert_date_string(this.item.tungay);
      this.denngay_selected = this.$convert_date_string(this.item.denngay);
    },
    closeModal() {
      this.modalShow = false;
    },
    storeAllItem() {
      var from_date = this.$convert_string_date(this.$convert_date_string(this.hopdong.ngayhieuluc));
      var to_date = (this.hopdong.ngayhethan == null) ? this.$convert_string_date("31/12/2049") : this.hopdong.ngayhethan;

      var xangxe = {id: 0, employeeContractId: 0, tungay: from_date, denngay: to_date, phucap: this.phucaps[0].id, tien: this.item_all.xangxe}
      this.items.push(xangxe);

      var dienthoai = {id: 0, employeeContractId: 0, tungay: from_date, denngay: to_date, phucap: this.phucaps[1].id, tien: this.item_all.dienthoai}
      this.items.push(dienthoai);

      var nhao = {id: 0, employeeContractId: 0, tungay: from_date, denngay: to_date, phucap: this.phucaps[2].id, tien: this.item_all.nhao}
      this.items.push(nhao);

      var trangphuc = {id: 0, employeeContractId: 0, tungay: from_date, denngay: to_date, phucap: this.phucaps[3].id, tien: this.item_all.trangphuc}
      this.items.push(trangphuc);

      var hotronuoicon = {id: 0, employeeContractId: 0, tungay: from_date, denngay: to_date, phucap: this.phucaps[4].id, tien: this.item_all.hotronuoicon}
      this.items.push(hotronuoicon);

      this.closeAllModal();
      this.$toast.info("Vui lòng nhập bấm LƯU để hoàn tất PHỤ CẤP", "Nhắc nhở", {timeout: 3000,});
    },
    storeItem(bvModalEvt) {
      if (this.tungay_selected == "") { this.$toast.error("Vui lòng nhập TỪ NGÀY", "Lỗi", {timeout: 2000,}); return;}
      if (this.denngay_selected == "") this.denngay_selected = "31/12/2049"; // @HACK: Temporary date that is far in the future for now.
      if (!this.testDate(this.tungay_selected )) {this.$toast.error("Vui lòng nhập đúng định dạng dd/mm/yyy TỪ NGÀY", "Lỗi", {timeout: 2000,}); return;}
      if (!this.testDate(this.denngay_selected )) { this.$toast.error("Vui lòng nhập đúng định dạng dd/mm/yyy TỪ NGÀY", "Lỗi", {timeout: 2000,}); return; }

      this.item.tungay = this.$convert_string_date(this.tungay_selected );
      this.item.denngay = this.$convert_string_date(this.denngay_selected);

      if (!this.item.tungay || !this.item.phucap) { this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {timeout: 2000}); bvModalEvt.preventDefault(); return;}

      const myitem = this.item;
      const moment = this.$moment;
      const phucap_exits = this.items.find(function (el) {
        if (el.phucap == myitem.phucap &&
          ((moment(myitem.tungay).isSameOrBefore(el.tungay, "day") && moment(el.tungay).isSameOrBefore(myitem.denngay, "day"))
           || (moment(el.tungay).isSameOrBefore(myitem.tungay, "day") && moment(myitem.tungay).isSameOrBefore(el.denngay, "day"))
           || (moment(myitem.tungay).isSameOrBefore(el.denngay, "day") && moment(el.denngay).isSameOrBefore(myitem.denngay, "day")))
        )
          return el;
      });

      if (phucap_exits) {this.$toast.error("Phụ cấp đã tồn tại trong thời gian này!", "Lỗi", {timeout: 2000,}); return;}

      this.items.push(this.item);
      this.modalShow = false;
      this.$toast.info("Vui lòng nhập bấm LƯU để hoàn tất PHỤ CẤP", "Nhắc nhở", {timeout: 3000,});
    },
    updateItem(bvModalEvt) {
      if (this.tungay_selected == "") {this.$toast.error("Vui lòng nhập TỪ NGÀY", "Lỗi", {timeout: 2000,}); return;}
      if (this.denngay_selected == "") this.denngay_selected = "31/12/2049"; // @HACK: Temporary date that is far in the future for now.
      if (!this.testDate(this.tungay_selected )) {this.$toast.error("Vui lòng nhập đúng định dạng dd/mm/yyy TỪ NGÀY", "Lỗi", {timeout: 2000,}); return;}
      if (!this.testDate(this.denngay_selected )) {this.$toast.error("Vui lòng nhập đúng định dạng dd/mm/yyy TỪ NGÀY", "Lỗi", {timeout: 2000,}); return;}

      this.item.tungay = this.$convert_string_date(this.tungay_selected);
      this.item.denngay = this.$convert_string_date(this.denngay_selected);

      if (!this.item.tungay || !this.item.phucap) {this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {timeout: 2000}); bvModalEvt.preventDefault(); return}

      const myitem = this.item;
      const moment = this.$moment;
      const index = this.items.findIndex(function (el) {
        if (el.phucap == myitem.phucap &&
          ((moment(myitem.tungay).isSameOrBefore(el.tungay, "day") && moment(el.tungay).isSameOrBefore(myitem.denngay, "day"))
            || (moment(el.tungay).isSameOrBefore(myitem.tungay, "day") && moment(myitem.tungay).isSameOrBefore(el.denngay, "day"))
            || (moment(myitem.tungay).isSameOrBefore(el.denngay, "day") && moment(el.denngay).isSameOrBefore(myitem.denngay, "day")))
        )
          return el;
      });

      if (index >= 0 && index != this.itemIdex) {this.$toast.error("Phụ cấp đã tồn tại trong thời gian này!", "Lỗi", {timeout: 2000}); return;}

      this.items[this.itemIdex] = this.item;
      this.items = JSON.parse(JSON.stringify(this.items));
      this.modalShow = false;
      this.$toast.info("Vui lòng nhập bấm LƯU để hoàn tất PHỤ CẤP", "Nhắc nhở", {timeout: 3000,});
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              this.items.splice(data.index, 1);
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    testDate(str){
      var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if(t===null) return false;
      var d=parseInt(t[1]), m=parseInt(t[2],10), y=parseInt(t[3],10);
      //below should be more acurate algorithm
      if(m>=1 && m<=12 && d>=1 && d<=31){
              return true;
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
